import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Problema } from "@/components/landing/Problema";
import { Solucion } from "@/components/landing/Solucion";
import { Beneficios } from "@/components/landing/Beneficios";
import { Modulos } from "@/components/landing/Modulos";
import { Bonos } from "@/components/landing/Bonos";
import { Inversion } from "@/components/landing/Inversion";
import { Garantia } from "@/components/landing/Garantia";
import { Urgencia } from "@/components/landing/Urgencia";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { StickyBar } from "@/components/landing/StickyBar";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#070B12] text-slate-100 antialiased">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <Hero />
      <Marquee />
      <main>
        <Problema />
        <Solucion />
        <Beneficios />
        <Modulos />
        <Bonos />
        <Inversion />
        <Garantia />
        <Urgencia />
        <Faq />
        <FinalCta />
      </main>
      <StickyBar />
    </div>
  );
}

export default App;
